import { useEffect } from 'react';
import { useMatch, Outlet, useNavigate } from 'react-router-dom';
import { PermissionEnum, PermissionDenied, IconLoader } from '@ui/src';
import { useAppSelector } from '@store';
import ROUTES from '../../routes';

import cn from './styles.module.css';

const Administration = (): React.JSX.Element => {
  const navigate = useNavigate();

  const match = useMatch(ROUTES.SETTINGS);

  const { activePermissions } = useAppSelector(
    (state) => state.administrationDictionaries,
  );

  useEffect(() => {
    if (
      match &&
      activePermissions?.includes(PermissionEnum.SECTION_ADMINISTRATION)
    ) {
      navigate(ROUTES.CURRENCIES);
    }
  }, [match, activePermissions]);

  useEffect(() => {
    let title = 'Administration';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.administrationLoader}>
      <IconLoader />
    </div>
  );

  if (activePermissions) {
    if (!activePermissions.includes(PermissionEnum.SECTION_ADMINISTRATION)) {
      content = <PermissionDenied />;
    } else {
      content = <Outlet />;
    }
  }

  return content;
};

export default Administration;
